<template>
  <div class="albums-container">
    <h2>My Albums</h2>
    <div v-if="loading">Loading...</div>
    <div v-if="loadingError">There was an error: {{loadingError.message}}</div>
    <div v-if="albums">
      <AlbumList :albums="albums" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import AlbumList from './AlbumList'
export default {
  data() {
    return {
      loading: false,
      loadingError: null,
    }
  },
  mounted() {
    this.loading = true
    axios.get('/api/albums').then(response => {
      this.$store.commit('setAlbums', response.data.albums)
    }).catch(error => {
      this.loadingError = error
    }).then(() => {
      this.loading = false
    })
  },
  computed: mapState({
    albums: state => state.albums,
  }),
  components: {
    AlbumList
  }
}
</script>

<style lang="stylus" scoped>
.albums-container
  min-width 200px

.albums-mobile

  h2
    color #fff
    border-bottom: 2px dotted #f2cf63

</style>
